"use strict";

exports.__esModule = true;
exports.StatisticsCalculationsSelector = void 0;
var _react = _interopRequireWildcard(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _helper = require("../../Widgets/MeasureChart/helper");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var StatisticsCalculationsSelector = exports.StatisticsCalculationsSelector = function StatisticsCalculationsSelector(props) {
  var _useContext = (0, _react.useContext)(_Core.TranslatorContext),
    translate = _useContext.translate;
  var elementEditor = props.elementEditor,
    path = props.path,
    statistics = props.statistics;
  (0, _react.useEffect)(function () {
    if (!statistics || Object.entries(statistics).length === 0) {
      elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.statistics",
          value: el.props.statistics = {
            minShow: false,
            maxShow: false,
            avgShow: false,
            medShow: false
          }
        };
      });
    }
  }, [statistics, elementEditor, path]);
  return /*#__PURE__*/_react["default"].createElement(_helper.Well, {
    "data-testid": "StatisticsCalculationsSelector"
  }, /*#__PURE__*/_react["default"].createElement(_helper.WellTitle, null, translate("StatisticsCalculationsSelector.statisticsOptions.label", "Statistics options")), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("StatisticsCalculationsSelector.statisticsShowMinValue.switch", "Show min value"),
    "data-testid": "StatisticsCalculationsSelector.statisticsShowMinValue.switch",
    checked: statistics == null ? void 0 : statistics.minShow,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.statistics.minShow",
          value: el.props.statistics.minShow = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("StatisticsCalculationsSelector.statisticsShowMaxValue.switch", "Show max value"),
    "data-testid": "StatisticsCalculationsSelector.statisticsShowMaxValue.switch",
    checked: statistics == null ? void 0 : statistics.maxShow,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.statistics.maxShow",
          value: el.props.statistics.maxShow = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("StatisticsCalculationsSelector.statisticsShowAverageValue.switch", "Show average value"),
    "data-testid": "StatisticsCalculationsSelector.statisticsShowAverageValue.switch",
    checked: statistics == null ? void 0 : statistics.avgShow,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.statistics.avgShow",
          value: el.props.statistics.avgShow = e.target.checked
        };
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_core.Switch, {
    label: translate("StatisticsCalculationsSelector.statisticsShowMedValue.switch", "Show median value"),
    "data-testid": "StatisticsCalculationsSelector.statisticsShowMedValue.switch",
    checked: statistics == null ? void 0 : statistics.medShow,
    onChange: function onChange(e) {
      return elementEditor.modifyElementAt(path, function (el) {
        return {
          item: "el.props.statistics.medShow",
          value: el.props.statistics.medShow = e.target.checked
        };
      });
    }
  }));
};